/*eslint-disable react/no-set-state*/
import React, {PropTypes} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';
import SessionStorageService from '../../../services/sessionStorage/sessionStorageService';
import docCookies from '../../../services/cookieStorage/cookieStorage';
import {searchForFormById} from '../../../selectors/searchForForm';
import * as loginActions from '../../../actions/loginActions';
import * as pathConstants from '../../../constants/pathConstants';
import * as errorMessages from '../../../constants/errorMessages';
import * as FormName from '../../../constants/formNameConstants';
import LoginForm, {backdropStyle} from './LoginForm';
import '../../../styles/login/login.css';
import {Modal} from 'react-overlays';
import Button from '../../common/Button';

export class LoginPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      credentials: Object.assign({}, this.props.credentials),
      loggingIn: false,
      formIsValid: false,
      formErrors: {},
      ombForm: {},
      ombForm2: {},
      showLoginModal: false
    };

    // if user has session data, redirect any access of login page to the home page
    // don't automatically log in if it's been over a certain amount of time
    let timeDiff = '';
    let storedTime = '';
    if (sessionStorage.getItem('lastLogin')) {
      let currentTime = +new Date();
      storedTime = sessionStorage.getItem('lastLogin');
      timeDiff = (currentTime - storedTime) / 3600 / 1000;
    }
    if (this.props.session && storedTime !== '' && this.props.session.username
        && timeDiff !== '' && timeDiff < 4) {
      const newCredentials = {
        email: this.props.session.username,
        password: this.props.session.password
      };
      this.login(newCredentials);
    }
    this.login = this.login.bind(this);
    this.loginClick = this.loginClick.bind(this);
    this.enteringCredentials = this.enteringCredentials.bind(this);
    this.redirect = this.redirect.bind(this);
    this.confirmFormIsValid = this.confirmFormIsValid.bind(this);
    this.showSubModal = this.showSubModal.bind(this);
    this.closeSubModal = this.closeSubModal.bind(this);
    this.getModalState = this.getModalState.bind(this);
  }

  enteringCredentials(event) {
    event.preventDefault();
    const field = event.target.name;
    let credentials = this.state.credentials;
    credentials[field] = event.target.value;
    this.setState({credentials: credentials});
    this.setState({
      formIsValid: this.confirmFormIsValid()
    });
  }
  loginClick(event) {
    event.preventDefault();
    this.login(this.state.credentials);
  }
  login(credentials) {
    this.setState({loggingIn: true});
    this.props.actions.login(credentials)
      .then((response) => {
        if (response.authenticated) {
          let loginDate = +new Date();
          sessionStorage.setItem('lastLogin', loginDate);
          sessionStorage.setItem('cookieName', response.session_name);
          sessionStorage.setItem('onLogin', '1');
          sessionStorage.setItem('helpRedirect', '1');
          docCookies.setItem(response.session_name, response.session_id, null, '/');
          this.redirect(this.props.pathIntended);
        } else {
          const logouturl = window.location.origin+pathConstants.pathToLogout;
          window.location = logouturl;
        }
      })
      .catch(error => {
        throw(error);
      });
    this.setState({loggingIn: false});
  }
  confirmFormIsValid() {
    let errors = {};
    let formIsValid = true;
    const credentials = this.state.credentials;

    if (!credentials.email) {
      errors.email = errorMessages.ERROR_LOGIN_NO_USERNAME;
      formIsValid = false;
    }
    if (!credentials.password) {
      errors.password = errorMessages.ERROR_NO_PASSWORD;
      formIsValid = false;
    }
    this.setState({formErrors: errors});
    return formIsValid;
  }

  redirect(path) {
    browserHistory.push(path);
  }

  showSubModal() {
    this.setState({showLoginModal: true});
    return this.state.showLoginModal;
  }
  closeSubModal() {
    this.setState({showLoginModal: false});
    return this.state.showLoginModal;
  }
  getModalState() {
    return this.state.showLoginModal;
  }
  render() {
    return (
      <div>
        <div className="login-modal-container">
          <Modal
            key="extend-session"
            className="login-modal"
            backdropStyle={backdropStyle}
            show={this.state.showLoginModal}
            onHide={this.closeSubModal}>
            <div className="login-modal-dialog">
              <div id="login-title">
                <br/>
                <div>
                 Only a small fraction of establishments are required to electronically submit their Form 300A data to OSHA.
                  Establishments that meet <strong><i>any</i></strong> of the following criteria <strong>DO NOT</strong> have to send their information to us.
                  Remember, these criteria apply at the establishment level, not to the firm as a whole.
                </div>
                <br/>
                <div>
                  <ul>
                    <li>The establishment's peak employment during the previous calendar year was 19 or fewer, regardless of the establishment's industry.
                    </li>
                    <li>The establishment's industry <strong>is on <i>this</i></strong> <a href="https://www.osha.gov/recordkeeping/ppt1/RK1exempttable.html"
                     title="Partially Exempt Industries">list</a>,
                     regardless of the size of the establishment.</li>
                    <li>The establishment had a peak employment between 20 and 249 employees during the previous
                    calendar year AND the establishment's industry <strong>is <i>NOT</i> on <i>this </i></strong>
                    <a href="https://www.osha.gov/recordkeeping/NAICScodesforelectronicsubmission.html" title="NAICS codes">list</a>.</li>
                  </ul>
                </div>
              </div>
              <br/>
                <form id="login-reminder-container">
                  <div className="login-buttons">
                    <span className="extend">
                      <Button
                        value="OK"
                        disabled={false}
                        onClick={this.closeSubModal}
                        className="login-btn"/>
                    </span>
                  </div>
                </form>
            </div>
          </Modal>
    </div>
        <LoginForm
          onChange={this.enteringCredentials}
          onSubmit={this.loginClick}
          formErrors={this.state.formErrors}
          loggingIn={this.state.loggingIn}
          submitStatus={this.state.formIsValid}
          passwordResetHidden={this.props.passwordResetHidden}
          showSubmissionModal={this.showSubModal}
          ombForm={this.props.ombForm}
          ombForm2={this.props.ombForm2}/>
      </div>
    );
  }
}

// Pull in the React Router context so router is available on
// this.context.router.
LoginPage.contextTypes = {
  router: PropTypes.object
};

LoginPage.propTypes = {
  actions: PropTypes.object.isRequired,
  credentials: PropTypes.object.isRequired,
  pathIntended: PropTypes.string.isRequired,
  session: PropTypes.object,
  passwordResetHidden: PropTypes.bool,
  ombForm: PropTypes.object,
  ombForm2: PropTypes.object
};

function mapStateToProps(state, ownProps) {
  let pathIntended = ownProps.route.path;
  let passwordResetHidden = true;
  let session = JSON.parse(SessionStorageService.getItem('credentials')) || {};

  if (!pathIntended || pathIntended === pathConstants.pathToLogin) {
    pathIntended = pathConstants.pathToHome;
  } else if (pathIntended === pathConstants.pathToLoginWithPasswordReset) {
    pathIntended = pathConstants.pathToHome;
    passwordResetHidden = false;
  }

  let ombForm = {};
  let ombForm2 = {};
  if (state.forms.length > 0) {
    ombForm = searchForFormById(state.forms, FormName.ombMessage);
    ombForm2 = searchForFormById(state.forms, FormName.ombMessage2);
  }

  let credentials = {
    email: '',
    password: ''
  };
  return {
    credentials,
    pathIntended,
    passwordResetHidden,
    session,
    ombForm,
    ombForm2
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(loginActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);



/** WEBPACK FOOTER **
 ** ./src/components/authentication/login/LoginPage.js
 **/